import React from 'react'
import styled from 'styled-components'
import { colors } from '../utils/config'
import {
  LucideIconName,
  WebsiteConfigBM,
  WebsiteConfigPage,
} from '@bm-js/atlascloud-shared'
import { Icon } from '@bm-js/atlascloud-ui'

const StyledBreadcrumbs = styled.div<{ $base: string }>`
  display: flex;
  align-items: center;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  a {
    color: ${({ $base }) => $base};
    margin-right: 0.3rem;
    white-space: nowrap;
  }
  svg {
    width: 16px;
    height: 16px;
    margin-right: 0.3rem;
  }
  p {
    white-space: nowrap;
    color: ${colors.gray600};
  }
`

type Props = {
  websiteConfig: WebsiteConfigBM
  setActivePageFromNav: (page: WebsiteConfigPage) => void
  paths: WebsiteConfigPage[]
}

const Breadcrumbs = ({ paths, websiteConfig, setActivePageFromNav }: Props) => {
  const crumbs = paths.map((path) => {
    return {
      p: path.viewName,
      page: path,
    }
  })
  crumbs.splice(0, 0, {
    p: websiteConfig.pages[0].viewName,
    page: websiteConfig.pages[0],
  })
  return (
    <StyledBreadcrumbs $base={websiteConfig.colors.base} className='content'>
      {crumbs.map((crumb, i) => {
        if (i === crumbs.length - 1) {
          return <p key={`breadcrumbs_${i}_${crumb.p}`}>{crumb.p}</p>
        } else
          return (
            <React.Fragment key={`breadcrumbs_${i}_${crumb.p}`}>
              <a onClick={() => setActivePageFromNav(crumb.page)} href='#'>
                {crumb.p}
              </a>
              <span color={websiteConfig.colors.base}>
                <Icon name={LucideIconName.ChevronRight} />
              </span>
            </React.Fragment>
          )
      })}
    </StyledBreadcrumbs>
  )
}

export default Breadcrumbs
